import { render } from "./Behance.vue?vue&type=template&id=00c919e0"
import script from "./Behance.vue?vue&type=script&lang=js"
export * from "./Behance.vue?vue&type=script&lang=js"
script.render = render

export default script